import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import strings from "translate/language";
import { addFollowUp } from "reduxStore/action/followUpActions";
import { useDispatch, useSelector } from "react-redux";
import { getFollowupStatus } from "reduxStore/action/masterActions";
import moment from "moment";
import { handleListResponse, seo } from "utils/utils";
import TimePicker from "react-time-picker";
import Breadcrumb from "component/common/breadcrumb";
import { leadType } from "utils/constants";
import { nextDaycallId } from "../../utils/constants";

const AppointmentFollowup = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [formVaild, setFormVaild] = useState({});
  const [viewData, setViewData] = useState({});
  const params = useParams();

  const { lead_id = null ,appointment_id=null } = params || {};
  const allFollowupDetail = useSelector((state) => state.followUp) || {};
  const followupStatus = useSelector((state) => state.followupstatus);
  const navigatpage = async (navname) => {
    navigate(navname);
  };
  const [form, setForm] = useState({
    followup_status: nextDaycallId, // Not necessary anymore since we are focusing only on next follow-up
    next_followup_date: "",
    followup_time: "",
    remark: "",
  });

  useEffect(() => {
    if (allFollowupDetail.response) {
      const { response, addFollowupresponse = null } = allFollowupDetail;
      if (response?.status === 200) {
        setViewData(handleListResponse(response.data));
      } else {
        setViewData([]);
      }
      if (addFollowupresponse && addFollowupresponse?.status === 200) {
        navigatpage("/followUp");
      }
    }
  }, [allFollowupDetail]);

  useEffect(() => {
    dispatch(getFollowupStatus()); // You may want to remove this if follow-up status isn't used.
  }, []);

  const statusUpdate = () => {
    if (!handleValid()) {
      const post = {
        followup_status: nextDaycallId,
        next_followup_date: form.next_followup_date,
        followup_time: form.followup_time,
        remark: form.remark,
        lead_id: lead_id,
        appointment_id: appointment_id,
      };
      dispatch(addFollowUp(post));
    }
  };
  const handleInputField = (e) => {
    const nextFormState = {
      ...form,
      [e.target.name]: e.target.value,
    };
    setForm(nextFormState);
  };
  const handleInputTime = (followup_time) => {
    if (followup_time) {
      const nextFormState = {
        ...form,
        followup_time: moment("2000-01-01 " + followup_time).format("hh:mm A"),
      };
      setForm(nextFormState);
    }
  };

  const handleValid = () => {
    let err = {};
    let formError = false;

    const currentDateTime = moment(); // Current Date and Time
    const selectedDateTime = moment(
      form.next_followup_date + " " + form.followup_time,
      "YYYY-MM-DD hh:mm A"
    );

    if (selectedDateTime.isBefore(currentDateTime, 'minute')) {
    if (form.next_followup_date === moment().format("YYYY-MM-DD") && form.followup_time) {
      formError = true;
      err["followup_time"] = strings.invalidTimeError; // Custom error message for invalid time
    }
  }

    if (!form.next_followup_date) {
      formError = true;
      err["next_followup_date"] = strings.followup_dateErr;
    }
    if (!form.remark) {
      formError = true;
      err["remark"] = strings.remarkErr;
    }

    if (!form.followup_time) {
      formError = true;
      err["followup_time"] = strings.followup_timeErr;
    }

    setFormVaild(err);
    return formError;
  };
  useEffect(() => {
    seo({
      title: "Next Followup",
      metaDescription: "Schedule next followup",
      canonicalLink: window.location.href,
    });
  }, []);

  return (
    <div className="page-body">
      <Breadcrumb
        title={strings.newFollowup}
        url={"/followup"}
        parentListing={strings.followupList}
        titleactive={strings.NewFollowup}
        isBackBtn={true}
      />
      <div className="container-fluid">
        <div className="row">
          <div className="col-sm-12">
            <div className="card">
              <div className="card-header pb-0">
                <h5>{strings.newFollowup}</h5>
              </div>
              <form className="form theme-form">
                <div className="card-body">
                  {/* Only next follow-up options */}
                  <div className="row">
                    <div className="col-md-8">
                      <div className="mb-3">
                        <label htmlFor="exampleFormControlFirstName">
                          {strings.status}
                        </label>
                        <label className="form-control digits">
                          {strings.nextDayCall}
                        </label>
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-4">
                      <div className="mb-3">
                        <label htmlFor="nextFollowupDate">
                          {strings.date}
                          <span className="required-field"></span>
                        </label>
                        <input
                          className="form-control datetimepicker-input digits"
                          type="date"
                          name="next_followup_date"
                          value={form.next_followup_date}
                          onChange={handleInputField}
                          min={moment().add(1, "day").format("YYYY-MM-DD")}
                        />
                        {formVaild.next_followup_date && (
                          <span style={{ color: "red" }}>
                            {formVaild.next_followup_date}
                          </span>
                        )}
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="mb-3">
                        <label htmlFor="followupTime">
                          {strings.time}
                          <span className="required-field"></span>
                        </label>
                        <TimePicker
                          onChange={handleInputTime}
                          value={form.followup_time}
                          type="time"
                          clockIcon={null}
                          clearIcon={null}
                          disableClock={true}
                          format={"hh:mm a"}
                          className="form-control"
                          name="followup_time"
                        />
                        {formVaild.followup_time && (
                          <span style={{ color: "red" }}>
                            {formVaild.followup_time}
                          </span>
                        )}
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-8">
                      <div className="mb-3">
                        <label htmlFor="remark">
                          {strings.description}
                          <span className="required-field"></span>
                        </label>
                        <textarea
                          className="form-control"
                          name="remark"
                          value={form.remark}
                          onChange={handleInputField}
                          id=""
                          cols="74"
                          rows="5"
                        ></textarea>
                        {formVaild.remark && (
                          <span style={{ color: "red" }}>
                            {formVaild.remark}
                          </span>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-12 d-flex justify-content-end">
                      <div className="card-footer">
                        <button
                          className="btn btn-color"
                          type="button"
                          onClick={statusUpdate}
                        >
                          {strings.update}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <hr className="class-1" />
                {/* Display Existing Followup Data */}
                {viewData?.length > 0 ? (
                  viewData.map((item, index) => (
                    <div key={index} className="card-body pt-0">
                      <div className="row pt-0">
                        <div className="col-md-3 align-items-center">
                          <label htmlFor="followupBy">
                            {strings.followupBy}:
                          </label>
                        </div>
                        <div className="col-md-7 align-items-center">
                          <label htmlFor="followupBy" className="boldText">
                            {item.creator_name}
                          </label>
                        </div>
                      </div>
                      <hr />
                      <div className="row pt-0">
                        <div className="col-md-3 align-items-center">
                          <label htmlFor="followupDateTime">
                            {strings.date} & {strings.time}:
                          </label>
                        </div>
                        <div className="col-md-7 align-items-center">
                          <label
                            htmlFor="followupDateTime"
                            className="boldText"
                          >
                            {item.next_followup_date
                              ? `${moment(item.next_followup_date).format(
                                  "DD-MM-yyyy"
                                )} & ${item.followup_time}`
                              : "-"}
                          </label>
                        </div>
                      </div>
                      <hr />
                      <div className="row pt-0">
                        <div className="col-md-3 align-items-center">
                          <label htmlFor="remark">{strings.description}:</label>
                        </div>
                        <div className="col-md-7 align-items-center">
                          <label htmlFor="remark" className="boldText">
                            {item.remark ? item.remark : "-"}
                          </label>
                        </div>
                      </div>
                      <hr className="class-1 mb-0" />
                    </div>
                  ))
                ) : (
                  <h5 className="text-center">{strings.notavailable}</h5>
                )}
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default AppointmentFollowup;
